import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            change: {
                'filter': 'onFilterChange'
            }
        }
    }

    init() {
        this.items = Array.from(this.$('item'))
    }

    onFilterChange(e) {
        const filter = e.curTarget.value;

        // Hide everything
        this.items.forEach(item => { item.classList.add('-hidden') })

        // Wait a frame then show items matching filter
        requestAnimationFrame(() => {
            this.items.forEach(item => {
                const tags = this.getData('tags', item)
                const show = filter == 'all' ? true : tags.includes(filter)

                if(show) item.classList.remove('-hidden')

                // Reset inview state
                item.classList.remove('is-inview')
                item.querySelectorAll('.is-inview').forEach(item => item.classList.remove('is-inview'))
            })

            this.call('update', null, 'Scroll')
        })
    }
}
